/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import { g as getResumeCallBackData, a as getRealWebUrl } from '../../../common-42e7d8d8.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';
import '../../../safe-data-66f20265.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';

function navigateTo(params) {
    var handler = function (e) {
        var _a;
        (_a = params === null || params === void 0 ? void 0 : params.onResume) === null || _a === void 0 ? void 0 : _a.call(params, getResumeCallBackData(e));
        document.removeEventListener('WV.Event.APP.Active', handler, false);
    };
    document.addEventListener('WV.Event.APP.Active', handler, false);
    var formatInput = function (input) {
        var _a;
        return ({
            url: getRealWebUrl(input),
            popBeforeOpen: (_a = input.killSelf) !== null && _a !== void 0 ? _a : false,
        });
    };
    WVCall('WVNative.openWindow', params, { formatInput: formatInput });
}

export { navigateTo as default };
